import { ArrowLeft, ArrowUpRight } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import SeoHead from "@/seo/SeoHead";

const PAGE = {
  type: "page",
  title: "Industrial Project Management Insights | The PMC Perspective",
  description: "Practical insights from Asad Hatimi on CAPEX governance, project recovery, cost overruns, stage gates and industrial project delivery.",
  h1: "The PMC Perspective"
};

export default function InsightsPage({ articles }) {
  return (
    <div id="top" className="grain min-h-screen bg-ink text-ivory">
      <SeoHead page={PAGE} pathname="/insights" />
      <Nav />
      <main>
        <header className="border-b border-surface-2">
          <div className="mx-auto max-w-[1200px] px-6 pb-24 pt-40 md:px-16 md:pb-32 md:pt-48">
            <a
              href="/"
              className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] text-mutedfg hover:text-brass"
            >
              <ArrowLeft size={14} /> Main profile
            </a>
            <div className="mt-14 text-[11px] uppercase tracking-[0.28em] text-brass">
              Industrial project leadership · Field notes
            </div>
            <h1 className="mt-6 max-w-5xl font-serif-display text-6xl font-light leading-[0.92] tracking-[-0.025em] text-ivory md:text-8xl">
              The PMC Perspective<span className="text-brass italic">.</span>
            </h1>
            <p className="mt-10 max-w-3xl text-xl font-light leading-relaxed text-mutedfg">
              Practical writing on capital governance, project controls, recovery, cost, risk and the decisions
              that determine whether industrial programmes deliver.
            </p>
          </div>
        </header>

        <section className="border-b border-surface-2">
          <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-px bg-surface-2 px-6 py-24 md:grid-cols-2 md:px-16 md:py-32">
            {Object.entries(articles).map(([path, article], index) => (
              <a
                key={path}
                href={`${path}/`}
                className="placard group flex min-h-[390px] flex-col justify-between border border-transparent bg-ink p-9 md:p-12"
              >
                <div className="flex items-center justify-between">
                  <span className="text-[10px] uppercase tracking-[0.28em] text-brass">
                    {String(index + 1).padStart(2, "0")} · {article.eyebrow.split("·").pop().trim()}
                  </span>
                  <ArrowUpRight className="text-mutedfg transition-all group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-brass" size={19} />
                </div>
                <div>
                  <h2 className="font-serif-display text-3xl font-light leading-tight text-ivory transition-colors group-hover:text-brass md:text-4xl">
                    {article.h1}
                  </h2>
                  <p className="mt-6 font-light leading-relaxed text-mutedfg">{article.description}</p>
                  <div className="mt-8 text-[10px] uppercase tracking-[0.24em] text-mutedfg">
                    {article.readTime} · Read article
                  </div>
                </div>
              </a>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
